<template>
    <div>
        <h3 class="mt-2">Composição Familiar</h3>

        <template v-if="isIdoso">

            <div class="col-12 px-0">
                <Composicao :item="item" />
            </div>
        
            <DinamicaRelacao :item="item" @reload="submit" />

            <div class="row">

                <form-select
                    v-model="item.acompanhada_outros_orgao"
                    :itens="$root.arrays.pergunta"
                    label="A família da pessoa idosa é acompanhada por outros órgãos ou instituições?"
                />

                <form-input
                    v-if="item.acompanhada_outros_orgao == 1"
                    v-model="item.acompanhada_outros_qual"
                    label="Qual(ais)"
                />

                <form-input
                    v-model="item.rede_apoio"
                    label="Rede de apoio da pessoa idosa (listar pessoas/grupos que prestam algum tipo de suporte à pessoa idosa ou à sua família):"
                />

                <form-select
                    v-model="item.pessoas_imped_visita"
                    :itens="$root.arrays.acolhimento_pessoa_imped_visita"
                    label="Pessoas de referência impossibilitadas de realizar visitação"
                />

                <form-textarea-editor
                    label="Motivos:"
                    v-model="item.pessoa_imped_motivo"
                />

                <form-select
                    v-model="item.familia_relacao_idoso"
                    :itens="$root.arrays.acolhimento_fam_relacao_idoso"
                    label="Relação da Família com a pessoa idosa"
                />

                <form-select
                    v-model="item.idoso_relacao_familia"
                    :itens="$root.arrays.acolhimento_fam_relacao_idoso"
                    label="Relação da pessoa idosa com sua família:"
                />
                
                <form-textarea-editor
                    label="Percepção da Equipe SUAS"
                    :required="true"
                    v-model="item.parecer_equipe_tecnica"
                />

            </div>
            
        </template>
        
        <template v-else>

            <div class="row">

                <form-select
                    v-model="item.familiares_na_unidade"
                    :itens="$root.arrays.pergunta"
                    label="Possui irmãos nesta ou em outra unidade de acolhimento?"
                    :required="mostrarQtdeFamiliaFlag"
                    v-show="mostrarQtdeFamiliaFlag"
                />

            </div>

            <DinamicaFamiliar :item="item" @reload="submit" v-show="mostrarFamiliares"/>

            <div class="row">

                <form-select
                    v-model="item.outros_familia_acolhimento"
                    :itens="$root.arrays.pergunta"
                    label="Há outras pessoas da família em situação de acolhimento?"
                />

            </div>

            <DinamicaOutrosFamiliares :item="item" @reload="submit" v-show="mostrarOutrosFamiliares"/>
            
            <div class="row">

                <form-select
                    v-model="item.familia_relacao_idoso"
                    :itens="$root.arrays.acolhimento_fam_relacao_idoso"
                    label="Relações familiares"
                />

                <form-textarea-editor
                    label="Observações"
                    v-model="item.pessoa_imped_motivo"
                />

            </div>

        </template>
            
        <div class="row px-2 d-flex justify-content-end">
            <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                @click="submit"
                type="submit"
            >
                <i class="mdi mdi-content-save" />
                {{ $t("Salvar") }}
            </button>
        </div>
    </div>
</template>

<script>

import Composicao from "./Composicao";
import DinamicaRelacao from "./DinamicaRelacao";
import DinamicaFamiliar from "./DinamicaFamiliar";
import DinamicaOutrosFamiliares from "./DinamicaOutrosFamiliares";

export default {
    components: { Composicao, DinamicaRelacao , DinamicaFamiliar, DinamicaOutrosFamiliares},
    props: ["item"],
    data() {
        return {
            loading: false,
            mostrarQtdeFamiliaFlag: false,
            pessoaReferencia: {},
        };
    },
    mounted() {
        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;
        }

        if (this.item.familia_membros) {
            if (typeof this.item.familia_membros === "string") {
                // Se veio string, transforma em array com 1 item
                this.item.familia_membros = [this.item.familia_membros];
            }else if (!Array.isArray(this.item.familia_membros)) {
                // Se veio outro formato, força vazio
                this.item.familia_membros = [];
            }
        }else{
            this.item.familia_membros = [];
        }

        this.item.familiares_na_unidade      = this.mapPergunta(this.item.familiares_na_unidade);
        this.item.outros_familia_acolhimento = this.mapPergunta(this.item.outros_familia_acolhimento);

    },
    watch: {
        'item.familia_membros': {
            handler() {
                this.mostrarQtdeFamiliaFlag = this.mostrarQtdeFamilia;
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        isIdoso() {
            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            // Se existir público alvo, verifica se é 8, senão usa idade para decidir
            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
        mostrarQtdeFamilia() {
            if (!Array.isArray(this.item.familia_membros)) return false;
            // Mostra se algum id diferente de "0"
            return this.item.familia_membros.some(id => id !== "0");
        },
        mostrarFamiliares() {
            const possui_irmaos = this.item.familiares_na_unidade;
            return possui_irmaos === 1 || (possui_irmaos?.id === 1);
        },
        mostrarOutrosFamiliares() {
            const possui_outros_familiares = this.item.outros_familia_acolhimento;
            return possui_outros_familiares === 1 || (possui_outros_familiares?.id === 1);
        },
    },
    methods: {
        mapPergunta(v) {
            if (v === null || v === undefined) return 2; // trata null como NÃO
            if (v === 0 || v === "0") return 2; // NÃO
            if (v === 1 || v === "1") return 1; // SIM
            return 2; // fallback = NÃO
        },
        submit() {
            this.item.pessoaReferencia = this.pessoaReferencia;
            this.$emit("submit");
        },
    },
};
</script>
